import { ZCDFlex, ZCDSpacer, ZCDTypography } from '@zencity/common-ui';
import { ZCDFlexProps } from '@zencity/common-ui/lib/ZCD/ZCDFlex/ZCDFlex';
import { ZCDIconProps } from '@zencity/common-ui/lib/ZCD/ZCDIcon/ZCDIcon';
import { ZCDTypographyProps } from '@zencity/common-ui/lib/ZCD/ZCDTypography/ZCDTypography';
import React from 'react';
import { DELIMITER } from 'screens/WidgetGenerator/constants';
import { DiffIcon } from './DiffIcon';
import styles from './DiffIndicator.module.scss';

interface DiffIndicatorProps {
  currentValue: number;
  prevValue?: number;
  iconColor?: ZCDIconProps['color'];
  withSeparator?: boolean;
  justifyContent?: ZCDFlexProps['justifyContent'];
  typographyColor?: ZCDTypographyProps['color'];
  typographyVariant?: ZCDTypographyProps['variant'];
}

export function DiffIndicator(props: DiffIndicatorProps): React.ReactElement {
  const {
    currentValue,
    prevValue,
    iconColor,
    withSeparator = false,
    justifyContent = 'flex-start',
    typographyColor,
    typographyVariant,
  } = props;
  const diff = prevValue && Math.round(currentValue) - Math.round(prevValue);
  return (
    <ZCDFlex justifyContent={justifyContent} alignItems="center" width={65} className={styles.diffWrapper}>
      {withSeparator && (
        <ZCDTypography color={typographyColor} variant="t-mini">
          {DELIMITER}
        </ZCDTypography>
      )}
      {diff ? (
        <>
          <DiffIcon diff={diff} arrowColor={iconColor} />
          <ZCDTypography variant={typographyVariant} color={typographyColor} className={styles.diffText}>{`${Math.abs(
            diff,
          )}%`}</ZCDTypography>
        </>
      ) : (
        <ZCDFlex flexDirection="row" alignItems="center">
          <ZCDSpacer customSize={13} orientation="horizontal" />
          <ZCDTypography variant={typographyVariant} color={typographyColor}>
            --
          </ZCDTypography>
        </ZCDFlex>
      )}
    </ZCDFlex>
  );
}
